<template>
    <v-data-table
                    :headers="headers"
                    :items="clientChildList"
                    sort-by="name"
                    class="elevation-1"
            >
                <template v-slot:item.history.createdAt="{ item }">
                    {{item.history.createdAt | formatDateOnly}}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="showClient(item)"
                    >
                        mdi-text-box-search-outline
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    Нет данных
                </template>
            </v-data-table>
</template>

<script>
    export default {
        name: "ClientChild",
        created() {
            this.$store.dispatch('retrieveClientChild')
            this.$store.dispatch('retrieveClientServiceTypeDictionaryList')
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1
                    ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.ClientsCard.clientChild.crudName'))
                    : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.ClientsCard.clientChild.crudName'))
            },
            clientChildList() {
                return this.$store.getters.clientChildList.clients
            },
            serviceTypeDictionaryList(){
                return this.$store.getters.clientServiceTypeDictionaryList
            },
            canEditCard() {
                return this.$store.getters.hasRole(['Administrator', 'ClientManager'])
            },
        },
        data() {
            return {
                currentCompanyDictionaryId: null,
                dialog: false,
                dialogDelete: false,
                valid: !this.formError,
                vue: this,
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Clients.createAt'),
                        align: 'start',
                        sortable: true,
                        value: 'history.createdAt',
                    },
                    // {
                    //     text: this.$vuetify.lang.t('$vuetify.page.Clients.companyName'),
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'company.name',
                    // },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Clients.clientName'),
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Clients.address'),
                        align: 'start',
                        sortable: true,
                        value: 'address',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Clients.licenseType'),
                        align: 'start',
                        sortable: true,
                        value: 'licenseType.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Clients.serviceType'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceType.name',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.page.action.titleAction'), value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    id: null,
                    name: null,
                    number: null,
                    login: null,
                    password: null
                },
                defaultItem: {
                    id: null,
                    name: null,
                    number: null,
                    login: null,
                    password: null
                },
            }
        },
        methods: {
            editItem(item) {
                this.editedIndex = this.clientChildList.indexOf(item)

                this.editedItem = {...item}
                this.editedItem.isUpdate = true
                this.dialog = true
            },

            deleteItem(item) {
                this.editedIndex = this.clientChildList.indexOf(item)
                this.editedItem = {...item}
                this.dialogDelete = true
            },

            deleteItemConfirm() {
                let entity = this.clientChildList[this.editedIndex]

                this.$store.dispatch('deleteClientChild', entity.id).then(() => this.closeDelete())
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = {...this.defaultItem}
                    this.editedIndex = -1
                })
            },

            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = {...this.defaultItem}
                    this.editedIndex = -1
                })
            },
            save() {
                if (this.$refs.form.validate()) {
                    if (!this.editedItem.id) {
                        this.editedItem.id = this.$uuid.v4()
                        this.editedItem.isUpdate = false
                    }
                    this.$store.dispatch('setClientChild', this.editedItem).then(() => this.close())
                }
            },
            showClient(item){
                this.$router.push({
                    name: 'ClientsCard',
                    params: { clientId: item.id }
                })

            }
        }
    }
</script>

<style scoped lang="scss">
    .v-data-table ::v-deep table td{
        font-size: 1rem !important;
    }
</style>